import { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);
export const useCart = () => useContext(CartCtx);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("er_cart") || "[]"); } catch { return []; }
  });
  useEffect(() => { localStorage.setItem("er_cart", JSON.stringify(items)); }, [items]);

  const add = (product) => {
    setItems((prev) => {
      const ex = prev.find((i) => i.product_id === product.id);
      if (ex) return prev.map((i) => i.product_id === product.id ? { ...i, quantity: i.quantity + 1 } : i);
      return [...prev, { product_id: product.id, quantity: 1, name: product.name, price: product.price, image: product.image, category: product.category, pickup_only: !!product.pickup_only }];
    });
  };
  const remove = (pid) => setItems((prev) => prev.filter((i) => i.product_id !== pid));
  const setQty = (pid, q) => setItems((prev) => prev.map((i) => i.product_id === pid ? { ...i, quantity: Math.max(1, q) } : i));
  const clear = () => setItems([]);
  const count = items.reduce((a, i) => a + i.quantity, 0);
  const total = items.reduce((a, i) => a + i.price * i.quantity, 0);

  return <CartCtx.Provider value={{ items, add, remove, setQty, clear, count, total }}>{children}</CartCtx.Provider>;
}
